import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
//import { Button, Text, View } from '../../../src/Components/Themed';
import moment from 'moment-mini';
//import { MarketComponentApi, MarketComponentHelpers } from '../../../src/MarketComponents/api';
import { FlatList } from 'react-native';

import { Button, Text, View } from '../../Components/Themed';
import { MarketComponentApi, MarketComponentHelpers } from '../api';
import type { EventProps, LeagueProps, TournamentProps } from '../../types';
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { TeamImage } from '../../Components/Jerseys';

type LeagueScheduleProps = {
    league:LeagueProps,
    active_event?:string,
    onSelectEvent:(event:EventProps) => void
}

const LeagueSchedule = ({ league, active_event, onSelectEvent }:LeagueScheduleProps) => {
    const Colors = useColors();
    const [ date_data, setDateData ] = useState<{
        active_date?:string,
        unique_dates:string[],
        selected_time?:string
    }>({
        unique_dates:[]
    })
    const { active_date, unique_dates } = date_data;
    const [ league_data, setLeagueData ] = useState<{
        loading:boolean,
        events:EventProps[],
        tournaments:TournamentProps[]
    }>({
        loading:false,
        events:[],
        tournaments: []
    });
    const {events} = league_data;
    const dateRef = useRef<any>(null);

    useEffect(() => {
        if(!league){ return }
        let today = moment().format('YYYY-MM-DD')
        getDataFromServer(today)
    },[league]);

    const getDataFromServer = async(date:string) => {
        setLeagueData({ ...league_data, loading:true });
        //Get timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log(league.league_id)
        const { day, days, events } = await MarketComponentApi.getEventsByDate(league.league_id, date, timezone);
        let unique_times = MarketComponentHelpers.getUniqueTimesFromEvents(events)
        setDateData({
            unique_dates: days,
            active_date: day,
            selected_time: unique_times[0]
        })
        setLeagueData({ 
            ...league_data,
            loading:false,
            events
        });
        let active_date_index = days.findIndex(d => d === day);
        if(active_date_index > -1){
            setTimeout(() => {
                dateRef.current?.scrollToIndex({ animated: true, index: active_date_index });
            }, 250);      
        }

    }

    const date_events = useMemo(() => events.filter(e => moment(e.scheduled_datetime).format('YYYY-MM-DD') == active_date),[events.length, active_date, league?.league_id]);
    //let filtered_events = [ ...date_events ]
    
    //const unique_times = useMemo(() => MarketComponentHelpers.getUniqueTimesFromEvents(date_events),[date_events[0]?.event_id])
    //const unique_divisions = useMemo(() => MarketComponentHelpers.getUniqueDivisions(date_events),[date_events.length])
    //const unique_sub_divisions = useMemo(() => MarketComponentHelpers.getUniqueSubDivisions(filtered_events), [filtered_events.length])
    //const league_tourneys = tournaments.filter(t => t.league_id == league.league_id).sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())

    const renderDates = useCallback((data: { item:string, index:number }) => {
        const formatted_date = moment(data.item, 'YYYY-MM-DD');
        const selected = data.item == active_date ? true : false
        
        return (
            <Button 
                style={{ width:65, padding:5, borderRadius:22, alignItems:'center', margin:5 }} 
                transparent
                onPress={() => getDataFromServer(data.item)}
                >
                <Text theme={selected?'h1':'light'} size={14}>{formatted_date.format('ddd')}</Text>
                <Text theme={selected?'h1':'light'} size={12} textAlign="center">{formatted_date.format('MMM DD')}</Text>
            </Button>
        )
    },[active_date, league?.league_id]);

    const renderEvents = (data:{ item: EventProps, index:number }) => {
        const selected = active_event == data.item.event_id ? true : false
        if(!data.item.away || !data.item.home){ return <></> }
        return (
            <Button transparent style={{ padding:10, borderRadius:0, borderWidth:1, borderColor:selected ? Colors.text.success : Colors.borders.light }}
                onPress={() => onSelectEvent(data.item)}
            >
                <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                    <View style={{ flexDirection:'row', alignItems:'center' }}>
                        <View nativeID='away'>
                            <TeamImage 
                                team={data.item.away}
                                size={14}
                                league={league}
                            />
                        </View>
                        <Text theme='h2' color={selected?Colors.text.success:Colors.text.h1}> VS </Text>
                        <View nativeID='home'>
                            <TeamImage 
                                team={data.item.home}
                                size={14}
                                league={league}
                            />
                        </View>
                    </View>
                    <View style={{ flex:1, marginLeft:10, marginRight:10 }}>
                        <Text theme='h2' color={selected?Colors.text.success:Colors.text.h1}>{data.item.event_title}</Text>
                        <Text theme='light' color={selected?Colors.text.success:Colors.text.h1} size={10} style={{ marginTop:3 }}>{['scheduled','created'].includes(data.item.time_detail ?? '') ? moment(data.item.scheduled_datetime).format('MM/DD/YYYY hh:mm a'):data.item.time_detail}</Text>
                    </View>
                    <Icons.ChevronIcon color={selected?Colors.text.success:Colors.text.h1} size={12} direction='right'/>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <View transparent>
                <FlatList
                    key={`${league.league_id}_dates_list`}
                    ref={dateRef}
                    data={unique_dates}
                    extraData={[league_data.loading, league.league_id]}
                    renderItem={renderDates}
                    horizontal
                    //estimatedItemSize={unique_dates.length ?? 5}
                    windowSize={2}
                    initialNumToRender={6}
                    maxToRenderPerBatch={6}
                    getItemLayout={(_, index) => ({length: 75, offset: 75 * index, index})}
                    keyExtractor={item => `${league.league_id}_dates_${item}`}
                />
            </View>
            <View type='body' style={{ flex:1 }}>
                <FlatList
                    data={date_events.sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())}
                    renderItem={renderEvents}
                    key={'date_events'}
                    extraData={[league.league_id]}
                    keyExtractor={(item) => item.event_id.toString()}
                />
            </View>
        </View>
    )
}

export default LeagueSchedule